<template>
  <div class="taskslogs">
    <section class="section">
      <div class="container">
        <div class="columns is-vcentered">
          <div v-if="currentUserAccess('ProjectLogs',this.UserActions.CREATE,this.project_id)" class="column">
            <b-button class="button is-primary is-mobile" icon-left="plus-thick"
                      @click="addNewTaskLogClicked">
              {{ $t('tasks-logs.new-task-log-button') }}
            </b-button>
          </div>
        </div>
        <div class="columns">
          <div class="column is-full">
            <b-table class="tasks-logs-table" :data="tasksLogsData" :striped="true" :hoverable="true"
                     :mobile-cards="true" :loading="isLoading" :scrollable="true">
              <b-table-column field="date" :label="this.$t('tasks-logs.date-column')"
                              v-slot="props">
                {{ props.row.date }}
              </b-table-column>
              <b-table-column field="title" :label="this.$t('tasks-logs.title-column')"
                              v-slot="props">
                {{ props.row.title }}
              </b-table-column>
              <b-table-column field="duration_internal" :label="this.$t('tasks-logs.duration-internal-column')"
                              v-slot="props">
                {{ getFormattedTimeHour(props.row.duration_internal) }}
              </b-table-column>
              <b-table-column field="duration_external" :label="this.$t('tasks-logs.duration-external-column')"
                              v-slot="props">
                {{ getFormattedTimeHour(props.row.duration_external) }}
              </b-table-column>
              <b-table-column field="quantity" :label="this.$t('tasks-logs.quantity-column')"
                              v-slot="props">
                {{ getFormattedQuantityValue(props.row.quantity, props.row.unit) }}
              </b-table-column>
              <b-table-column field="logged_expected_quantity"
                              :label="this.$t('tasks-logs.logged-expected-quantity-column')"
                              v-slot="props">
                {{ getFormattedQuantityValue(props.row.logged_expected_quantity, props.row.unit) }}
              </b-table-column>
              <b-table-column field="logged_executed_performance"
                              :label="this.$t('tasks-logs.logged-executed-performance-column')"
                              v-slot="props">
                {{ getFormattedPerformance(props.row.logged_executed_performance, props.row.unit) }}
              </b-table-column>
              <b-table-column field="profit" :label="this.$t('tasks-logs.profit-column')"
                              v-slot="props">
                <p :style="profitTextStyle(props.row.profit)">{{ getFormattedPricing(props.row.profit) }}</p>
              </b-table-column>
              <b-table-column v-if="currentUserAccess('ProjectLogs',this.UserActions.DELETE,this.project_id)" 
                              :label="this.$t('tasks-logs.actions-column')" centered v-slot="props" width="10%">
                <b-tooltip :label="$t('common.edit')" position="is-top">
                  <b-button class="button is-primary is-small m-1"
                          @click="editTaskLogClicked(props.row.taskLog)" icon-left="pencil">
                  </b-button>
                </b-tooltip>
                <b-tooltip :label="$t('common.delete')" position="is-top">
                  <b-button class="button is-primary is-danger is-small m-1"
                          @click="deleteTaskLogClicked(props.row.taskLog)" icon-left="delete">
                  </b-button>
                </b-tooltip>
              </b-table-column>
            </b-table>
          </div>
        </div>
      </div>
      <b-modal
          :width="640"
          v-model="isTaskLogModalActive"
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal>
        <template #default="props">
          <TaskLog v-bind:project_id="project_id" v-bind:tasks_data="tasksData" v-bind:log_data="selected_log" v-bind:selected_date="selected_date" @close="props.close"
                   @taskLogAdded="readTasksLogsData" @taskLogUpdated="readTasksLogsData"></TaskLog>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>

import firebase from "firebase/app";
import TaskLog from "@/components/TaskLog";

export default {
  name: "TasksLogs",
  components: {
    TaskLog
  },
  props: {
    'project_id': {
      type: String,
    },
    'selected_date': {},
  },
  data() {
    return {
      modelDate: new Date(),
      selectedUntilDate: new Date((new Date()).setHours(23, 59, 59, 0)),
      selectedFromDate: new Date((new Date()).setHours(0, 0, 0, 0)),
      tasksData: [],
      tasksLogsData: [],
      isLoading: false,
      isTaskLogModalActive: false,
      selected_log: {}
    }
  },
  watch: {
    selected_date: function () {
      this.dateSelectClicked(this.selected_date)
    }
  },
  methods: {
    readTasksData: function () {
      this.tasksData = [];
      const functions = firebase.app().functions("europe-west3");
      const getTasksFunctions = functions.httpsCallable(this.getSubmitEndpoint());
      getTasksFunctions({action: "get_tasks", project_id: this.project_id, fill_meta: true})
          .then((result) => {
            console.log("tasks list result: ", result.data);
            if (result.data.tasks.length > 0) {
              result.data["tasks"].forEach((task) => {
                this.tasksData.push({
                  task: task,
                  title: task.title
                });
              });
            }
            console.log("tasksData: ", this.tasksData);
          })
          .catch((error) => {
            this.showError(error.message)
            console.log("Error getting tasks: ", error);
          });
    },
    readTasksLogsData: function () {
      this.isTaskLogModalActive = false;
      this.isLoading = true;
      this.tasksLogsData = [];
      this.selected_log = {};
      this.selected_log.document_id = "new"
      const functions = firebase.app().functions("europe-west3");
      const getTasksLogsFunction = functions.httpsCallable(this.getSubmitEndpoint());
      const payloadData = {
        action: "get_logs",
        project_id: this.project_id,
        task_id: "*",
        fill_meta: true,
        filters: [['date', '>=', this.selectedFromDate.toISOString()], ['date', '<', this.selectedUntilDate.toISOString()]]
      }
      getTasksLogsFunction(payloadData)
          .then((result) => {
            console.log("tasks logs list result: ", result.data);
            if (result.data.taskslogs.length > 0) {
              result.data["taskslogs"].forEach((taskLog) => {
                this.tasksLogsData.push({
                  taskLog: taskLog,
                  title: taskLog.parent.title,
                  duration_internal: taskLog.duration_internal,
                  duration_external: taskLog.duration_external,
                  quantity: taskLog.quantity,
                  unit: taskLog.parent.unit,
                  logged_executed_performance: taskLog.meta.executed_performance,
                  logged_expected_quantity: taskLog.meta.expected_quantity,
                  profit: taskLog.meta.profit,
                  date: this.getFormattedDate(taskLog.date),
                  document_id: taskLog.document_id
                });
              });
              console.log("taskslogs: ", this.tasksLogsData);
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            this.showError(error.message)
            console.log("Error getting tasks logs: ", error);
          });
    },
    deleteTaskWorklog: function (taskLog) {
      this.isLoading = true;
      const functions = firebase.app().functions("europe-west3");
      const deleteTaskLogFunction = functions.httpsCallable(this.getSubmitEndpoint());
      deleteTaskLogFunction({
        action: "delete_log",
        project_id: taskLog.project_id,
        task_id: taskLog.task_id,
        document_id: taskLog.document_id,
      }).then(() => {
        this.isLoading = false;
        this.showSuccess(this.$t('messages.task-log-deleted'));
        this.readTasksLogsData()
      }).catch((error) => {
        this.showError(error.message)
        console.log("Error deleting task log: ", error);
        this.isLoading = false;
      });
    },
    /*
     UI Events
     */
    dateSelectClicked: function (date) {
      const fromDate = date.setHours(0, 0, 0, 0)
      const untilDate = date.setHours(23, 59, 59, 0)
      this.selectedFromDate = new Date(fromDate)
      this.selectedUntilDate = new Date(untilDate)
      this.readTasksLogsData();
    },
    addNewTaskLogClicked: function () {
      this.readTasksData();
      this.selected_log = {};
      this.selected_log.document_id = "new";
      this.isTaskLogModalActive = true;
    },
    editTaskLogClicked: function (taskLog) {
      this.readTasksData();
      this.selected_log = taskLog;
      this.isTaskLogModalActive = true;
    },
    deleteTaskLogClicked: function (taskLog) {
      this.$buefy.dialog.confirm({
        title: this.$t('tasks-logs.delete-log-title').toString(),
        message: this.$t('tasks-logs.delete-log-message').toString(),
        confirmText: this.$t('tasks-logs.delete-log-button').toString(),
        cancelText: this.$t('common.cancel').toString(),
        type: 'is-danger',
        hasIcon: true,
        icon: 'delete',
        onConfirm: () => {
          this.deleteTaskWorklog(taskLog);
          this.readTasksData();
        }
      });
    }
  },
  mounted() {
    this.readTasksLogsData();
  }
};
</script>

<style scoped>
.tasks-logs-table {
  margin-top: 16px;
}
</style>
